"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stem;

var _exceptionListHelpers = require("../morphoHelpers/exceptionListHelpers");

var _stemHelpers = require("../morphoHelpers/stemHelpers");

var _detectAndStemSuffixes = require("./detectAndStemSuffixes");

var _detectAndStemSuffixes2 = _interopRequireDefault(_detectAndStemSuffixes);

var _getStemWordsWithTAndDEnding = require("./getStemWordsWithTAndDEnding.js");

var _checkExceptionsWithFullForms = require("../morphoHelpers/checkExceptionsWithFullForms");

var _checkExceptionsWithFullForms2 = _interopRequireDefault(_checkExceptionsWithFullForms);

var _detectAndStemRegularParticiple = require("./detectAndStemRegularParticiple");

var _stemModificationHelpers = require("./stemModificationHelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Get the stem from noun diminutives and plurals exceptions.
 *
 * @param {Object}    morphologyDataNL The data for stemming exception.
 * @param {string}      word                                The word to check.
 *
 * @returns {string} The stemmed word.
 */


var removeSuffixFromFullForms = function removeSuffixFromFullForms(morphologyDataNL, word) {
  /*
   * Checks whether the word is in the exception list of words ending in -er and gets either -e or -s suffix
   * If it is, remove the corresponding suffix.
   * e.g. lekkere -> lekker, bitters -> bitter
  */
  var _iterator = _createForOfIteratorHelper(morphologyDataNL.stemExceptions.removeSuffixesFromFullForms),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var exceptionClass = _step.value;
      var stemmedWord = (0, _stemHelpers.removeSuffixesFromFullForm)(exceptionClass.forms, exceptionClass.suffixes, word);

      if (stemmedWord) {
        return stemmedWord;
      }
    }
    /*
     * Checks whether the word is in one of the exception lists of nouns
     * for which a specific suffix needs to be stemmed (e.g. -s, -es, -eren, -er etc.)
     * e.g. kuddes -> kud, modes -> mod, revenuen -> revenu
     */

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(morphologyDataNL.stemExceptions.removeSuffixFromFullForms),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _exceptionClass = _step2.value;

      var _stemmedWord = (0, _stemHelpers.removeSuffixFromFullForm)(_exceptionClass.forms, _exceptionClass.suffix, word);

      if (_stemmedWord) {
        return _stemmedWord;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
/**
 * Checks if the word is on a stemming exception list.
 *
 * @param {string} word The word to check.
 * @param {Object} morphologyDataNL The Dutch morphology data file.
 * @returns {string|null} The stem or null if the word was not matched by any of the exception checks.
 */


var checkOtherStemmingExceptions = function checkOtherStemmingExceptions(word, morphologyDataNL) {
  /*
   * Checks whether the word is in the exception list of nouns or adjectives with specific suffixes that needs to be stemmed.
   * If it is return the stem here and run possible stem modification if it is required. e.g. modes -> mod -> mood
   */
  var stemFromFullForm = removeSuffixFromFullForms(morphologyDataNL, word);

  if (stemFromFullForm) {
    if ((0, _stemModificationHelpers.isVowelDoublingAllowed)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.exceptionsStemModifications, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes)) {
      stemFromFullForm = (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.doubleVowel);
      return (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.finalChanges);
    }

    return (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.finalChanges);
  }

  return null;
};
/**
 * Stems Dutch words.
 *
 * @param {string} word  The word to stem.
 * @param {Object} morphologyDataNL The Dutch morphology data file.
 *
 * @returns {string} The stemmed word.
 */


function stem(word, morphologyDataNL) {
  // Check whether the word is in the list of words with full forms for which we define the stem. If it is, return the canonical stem.
  var stemmedWord = (0, _checkExceptionsWithFullForms2.default)(morphologyDataNL, word);

  if (stemmedWord) {
    return stemmedWord;
  } // Check whether the word is a participle, and if yes, stem it and return the stem.


  stemmedWord = (0, _detectAndStemRegularParticiple.detectAndStemRegularParticiple)(morphologyDataNL, word);

  if (stemmedWord) {
    return stemmedWord;
  } // Check whether the word is on the list of words that should not be stemmed, and if yes, return the word. Example: gans -> gans


  var wordsNotToBeStemmed = morphologyDataNL.stemExceptions.wordsNotToBeStemmedExceptions;

  if ((0, _exceptionListHelpers.checkIfWordIsOnVerbExceptionList)(word, wordsNotToBeStemmed.verbs, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes) || (0, _exceptionListHelpers.checkIfWordEndingIsOnExceptionList)(word, wordsNotToBeStemmed.endingMatch) || wordsNotToBeStemmed.exactMatch.includes(word)) {
    return word;
  }
  /*
   * Check whether the word ends in -t/-te/-ten/-tend/-de/-den/-dend. If it does, run through a series of checks aimed at
   * predicting whether the -t/d is part of the stem or the suffix. If the word was matched in one of the checks, stem it
   * accordingly and return the stem. Example: boot -> boot, squasht -> squash
   */


  var tAndDEndings = morphologyDataNL.ambiguousTAndDEndings.otherTAndDEndings;

  var _iterator3 = _createForOfIteratorHelper(tAndDEndings),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var ending = _step3.value;

      if (word.endsWith(ending)) {
        stemmedWord = (0, _getStemWordsWithTAndDEnding.generateCorrectStemWithTAndDEnding)(morphologyDataNL, word);

        if (stemmedWord) {
          return stemmedWord;
        }
      }
    } // Check if the word is on any other stemming exception list, and if yes, return the correct stem.

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  stemmedWord = checkOtherStemmingExceptions(word, morphologyDataNL);

  if (stemmedWord) {
    return stemmedWord;
  } // If the word was not stemmed in any of the previous steps, run through the stemming algorithm which detects and stems suffixes.


  return (0, _detectAndStemSuffixes2.default)(word, morphologyDataNL);
}